/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_System_Logo_AltInputs */

const en_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Logo File`)
};

const fr_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de logo systeme`)
};

const de_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemlogo-Datei`)
};

const it_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File del logo di sistema`)
};

const ru_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл логотипа системы`)
};

const es_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo del logotipo del sistema`)
};

const zh_cn2_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统徽标文件`)
};

const ja_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システムロゴファイル`)
};

const hi_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिस्टम लोगो फ़ाइल`)
};

const pt_pt2_iframe_remote_system_logo_alt = /** @type {(inputs: Iframe_Remote_System_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de logotipo do sistema`)
};

/**
* | output |
* | --- |
* | "System Logo File" |
*
* @param {Iframe_Remote_System_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_system_logo_alt = /** @type {((inputs?: Iframe_Remote_System_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_System_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_system_logo_alt(inputs)
	if (locale === "de") return de_iframe_remote_system_logo_alt(inputs)
	if (locale === "it") return it_iframe_remote_system_logo_alt(inputs)
	if (locale === "ru") return ru_iframe_remote_system_logo_alt(inputs)
	if (locale === "es") return es_iframe_remote_system_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_system_logo_alt(inputs)
	if (locale === "ja") return ja_iframe_remote_system_logo_alt(inputs)
	if (locale === "hi") return hi_iframe_remote_system_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_system_logo_alt(inputs)
	return en_iframe_remote_system_logo_alt(inputs)
});